// extracted by mini-css-extract-plugin
module.exports = {"root":"TotalCount_root__l76s5"};